// extracted by mini-css-extract-plugin
export default {"heading":"Xv-z","corrected":"Yv-z","redirectVerbiageContainer":"Zv-z","redirectVerbiageText":"_v-z"};